import { get } from 'lodash';

export const selectDeviceType = state => get(state, 'global.common.deviceType', '');
